import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

// Lets a page (e.g. the documents grid, after an upload/delete) tell the global
// search bar in the persistent Layout to refresh its index — without the page
// having to pass a prop into Layout. Needed once Layout is a persistent shell
// rendered by _app (getLayout pattern) rather than per-page.

interface SearchRefreshValue {
  /** Bumped to signal the search bar to reload its searchable data. */
  trigger: number;
  refresh: () => void;
}

const SearchRefreshContext = createContext<SearchRefreshValue>({
  trigger: 0,
  refresh: () => undefined,
});

export const SearchRefreshProvider = ({ children }: { children: React.ReactNode }) => {
  const [trigger, setTrigger] = useState(0);
  const refresh = useCallback(() => setTrigger((t) => t + 1), []);
  const value = useMemo(() => ({ trigger, refresh }), [trigger, refresh]);
  return <SearchRefreshContext.Provider value={value}>{children}</SearchRefreshContext.Provider>;
};

export const useSearchRefresh = () => useContext(SearchRefreshContext);
